import { render, staticRenderFns } from "./DeviceRentalChargeView.vue?vue&type=template&id=b2ca169e&"
import script from "./DeviceRentalChargeView.vue?vue&type=script&lang=js&"
export * from "./DeviceRentalChargeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports